export default "__VITE_ASSET__NGAAaxUM__"